var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html-template"},[_c('div',[_c('p',[_vm._v("Html Template Example")]),_c('p',[_vm._v(_vm._s(_vm.mapTitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }